import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  ACTIONS,
  PRIZE_STATUS,
  verifyLanguage,
  SPIN_WIN_PRIZES,
  CURRENCY,
  CURRENCY_SYMBOL,
  convertNumToCurr,
  getEllipsis,
} from "../../constants/app-enums";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/services/event.service";
import { IPrizeCard } from "src/app/components/lootboxes/lootbox.interface";

@Component({
  selector: "app-prize-card",
  templateUrl: "./prize-card.component.html",
  styleUrls: ["./prize-card.component.scss"],
})
export class PrizeCardComponent {
  @Input({ required: true }) gameCard!: IPrizeCard;
  @Output() onAction = new EventEmitter<{ action: ACTIONS, data?: any }>();
  isMobile = (window.matchMedia &&  window.matchMedia("(max-device-width: 1024px)").matches) ||  screen.width <= 1024;
  PRIZE_STATUS = PRIZE_STATUS;
  ACTIONS = ACTIONS;
  SPIN_WIN_PRIZES = SPIN_WIN_PRIZES;
  lang = "";
  CURRENCY = CURRENCY;
  CURRENCY_SYMBOL = CURRENCY_SYMBOL;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private eventService: EventService
  ) {
    this.route.params.subscribe((params) => {
      const lang = params["lang"];
      if (lang && verifyLanguage(lang)) {
        this.lang = lang;
      } else {
        const localLang = localStorage.getItem("currentlang");
        if (localLang && verifyLanguage(localLang)) {
          this.lang = localLang;
        } else {
          const userLang = navigator.language?.split("-")[0];
          this.lang = userLang && verifyLanguage(userLang) ? userLang : "en";
        }
      }
    });
    this.translate.setDefaultLang("en");
    this.translate.use(this.lang);
    this.eventService.setLang(this.lang);
  }

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }

  getEllipsis(text: string, max: number) {
    return getEllipsis(text, max);
  }
}
